/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Friday, 5th April 2019
 *
 * Manages the state of the Login process.
 */
import { configure, observable, decorate, action } from 'mobx';
import { firebase } from 'containers/services/Firebase';
configure({ enforceActions: 'observed' });

class LoginStore {
  email = '';
  password = '';
  showPasswordText = false;
  isLoading = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  /**
   * Internal stores getter.  Note: NOT mobx computed
   */
  get stores() {
    return this.rootStore;
  }

  setField = (field, value) => {
    this[field] = value;
  };
  setLoading = value => {
    this.isLoading = value;
  };
  togglePasswordText = () => {
    this.showPasswordText = !this.showPasswordText;
  };
  handleEmailChange = e => {
    this.email = e.target.value;
  };
  handlePasswordChange = e => {
    this.password = e.target.value;
  };

  signIn = event => {
    event.preventDefault();
    this.setLoading(true);
    this.rootStore.portalStore.loading.showPageLoader();

    setTimeout(() => {
      // TODO: If account exists, check for approved device thumbprints
      // TODO: If device thumbprint is not approved, do not login, send verification email to authorize new device.

      // Handle Promise
      firebase.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          // Success
          // Reset
          this.stores.appStore.debug('Login.signIn() [action] Sign-in was successful, reset store.');
          this.resetStore();
        })
        .catch(error => {
          this.rootStore.portalStore.loading.hidePageLoader();
          this.setLoading(false);
          this.rootStore.appStore.error('user', error);
        });
    }, 100);
  };

  passwordReset = event => {
    var email = '';

    if (typeof event !== 'string') {
      event.preventDefault();
      email = this.email;
    } else {
      email = event;
    }

    this.setLoading(true);
    this.rootStore.portalStore.loading.showPageLoader();

    // Handle Promise
    firebase.auth
      .sendPasswordResetEmail(email)
      .then(() => {
        // Success

        // Reset
        this.rootStore.portalStore.snackbar.showSnackbarPasswordReset(
          'Password Reset email has been sent.',
          'info',
          email
        );
        this.resetStore();
      })
      .catch(error => {
        this.rootStore.portalStore.loading.hidePageLoader();
        this.setLoading(false);
        this.rootStore.appStore.error('user', error);
      });
  };

  resetStore() {
    // Delay so users don't see the fields clear on login
    setTimeout(() => {
      this.setField('email', '');
      this.setField('password', '');
      this.setField('showPasswordText', false);
      this.setLoading(false);
      this.rootStore.portalStore.loading.hidePageLoader();
    }, 1000);
    this.stores.appStore.debug('Login.resetStore() [action] Login store has been reset.');
  }
}
decorate(LoginStore, {
  email: observable,
  password: observable,
  showPasswordText: observable,
  isLoading: observable,
  signIn: action,
  passwordReset: action,
  togglePasswordText: action,
  handleEmailChange: action,
  handlePasswordChange: action,
  setLoading: action,
  setField: action,
  resetStore: action,
});

export default LoginStore;
